// extracted by mini-css-extract-plugin
module.exports = {"footer":"IRISFooter_footer__1xRFF","footerSection":"IRISFooter_footerSection__3hgBZ","sectionHeader":"IRISFooter_sectionHeader__3qxy6","logo":"IRISFooter_logo__kNPL-"};